import React from "react";
import { TextQuestionTypeSwitch } from "./TextQuestionTypeSwitch";
import { useController, useFormContext } from "react-hook-form";
import { TextQuestionTypes } from "survey";

interface PaziaTextQuestionTypeSwitchProps {
  name: string;
  onChange?: (type: TextQuestionTypes) => void;
}

export const PaziaTextQuestionTypeSwitch = ({ name, onChange }: PaziaTextQuestionTypeSwitchProps): JSX.Element => {
  const { control } = useFormContext();

  const { field } = useController({
    name,
    control,
    defaultValue: "text",
  });

  const onChangeHandler = (type: TextQuestionTypes) => {
    field.onChange(type);
    if (onChange) onChange(type);
  };

  return <TextQuestionTypeSwitch currentType={field.value} onChange={onChangeHandler} />;
};
